import { useStore } from 'effector-react'
import * as React from 'react'

import { $error, comment, mounted } from './model'

export const useCommentForm = () => {
  React.useEffect(() => {
    mounted()
  }, [])

  const error = useStore($error)

  const loading = useStore(comment.pending)

  return {
    form: {
      error,
      loading,
    },
  }
}
